import module from '../module';
import Constants from '../../../utils/CommonConstants';
import OrderSetupDialogController from '../../order/controllers/OrderSetupDialogController';
import scopeUtils from '../../../utils/scope';
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";
import {utils} from "../../../utils/shopifyInjector/utils";

export class OrderSetupService {
    static $inject = ['cartonomyConfig', '$window', '$mdDialog', 'Session', 'AuthenticationService', 'CartService', 'Message', 'GroupOrder','LocalForageService', '$state', '$rootScope'];

    constructor(cartonomyConfig, windowService, dialogService, sessionService, authenticationService, cartService, messageService, groupOrderService, localForageService, stateService, rootScope) {

        this._rootScope = rootScope;
        this._stateService = stateService;
        this._cartonomyConfig = cartonomyConfig;
        this._dialogService = dialogService;
        this._sessionService = sessionService;
        this._authenticationService = authenticationService;
        this._groupOrderService = groupOrderService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._windowService = windowService;
        this.isOrderCreating = false;
        this.orderSetupDialogShowing = false;
        //this._sessionStorageService = sessionStorageService;
        this._localForageService = localForageService;

        this._dialogOptions = null;
        this._inviteMoreOption = null;

        this.invitationPromise = null;
    }

    async _showOrderSetupDialog(options) {
        const cart = await this._cartService.getCart();
        this.orderSetupDialogShowing = true;
        if (!(options && options.tabToShow) && await this._cartService.isGroupOrder(cart)) {
            if (options.needAddItem) {
              await this._stateService.go(Constants.RoutingStates.USER_PROFILE);
              this._rootScope.$broadcast(Constants.Events.ORDER_CREATED);
                setTimeout(() => {
                    this._stateService.go(Constants.RoutingStates.CART);
                }, 0);
                return;
            }
            // this._messageService.showErrorPopup('You are already in a group order.  If you wish to create a new order you will need to cancel or leave the existing order.  You will now be taken to your current group order.')
            //
            // this._stateService.go(Constants.RoutingStates.CART);
            // return;
            await  this._rootScope.$broadcast(Constants.Events.INVITATION_ACCEPTED);
            await this._sessionService.setCartReference(null, false);
        }

        try {
            if(this._cartService.getInvitationType() !== 2)
                this._cartService.setInvitationType(Constants.InvitationTypes.normal);
            this._rootScope.$broadcast(Constants.Events.DIALOG_OPENED, options && options.__editMode);
            let self = this;
            this._dialogOptions = {
                controller: OrderSetupDialogController,
                template: require('../../order/views/orderSetupDialog.jade')(),
                // templateUrl: 'modules/order/views/orderSetupDialog.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: {
                    tabToShow: (options && options.tabToShow) || null,
                    initialConfiguration: (options && options.initialConfiguration) || {},
                    initialCart: (options && options.initialCart) || {},
                    paymentOptions: options && options.paymentOptions,
                    editMode: options && options.__editMode
                },
                onRemoving: function (event, removePromise) {
                    self._rootScope.$broadcast(Constants.Events.DIALOG_CLOSED);
                }
            };
            await this._dialogService.show(this._dialogOptions);
            return this._groupOrderService.serialize();
        } catch (error) {

        } finally {
            this.orderSetupDialogShowing = false;
        }
    }

    async reShowDialog() {
        if (this._dialogOptions) {
            await this._localForageService.store(Constants.SessionStorage.CREATE_ORDER_CURRENT_TAB, Constants.OrderSetupTabs.ADD_PEOPLE);
            await this._dialogService.show(this._dialogOptions);
            await this._localForageService.remove(Constants.SessionStorage.CREATE_ORDER_CONFIGURATION);
            await this._localForageService.remove(Constants.SessionStorage.CREATE_ORDER_CURRENT_TAB);
        }
        else if (this._inviteMoreOption)
            this._dialogService.show(this._inviteMoreOption);
        else
            console.log('_dialogOptions and _inviteMoreOption are null');
    }

    async hideDialog() {
        if (this._dialogOptions) {
            this._dialogService.hide();
        }
    }

    async showInviteMorePeople(emails){
        this._dialogOptions = null;
        this._inviteMoreOption = {
            templateUrl: 'modules/cart/views/addMorePeopleDialog.html',
            clickOutsideToClose: true,
            escapeToClose: true,
            controller: ['$scope', '$mdDialog', 'CartService', (scope, dialogService, CartService) => {

                scope.readOnly = false;
                scope.canAddEmail = false;

                scope.cancel = () => {
                    dialogService.hide();
                };
                
                scope.$on('order:add:people.canAddPeople', function (s, value) {
                    scope.canAddEmail = value;
                });

                scope.configuration = {
                    exclude: emails
                };

                scope.onEmailChanges = function (emails) {
                    scope.configuration.emails = emails;
                };

                scope.sendInvitation = () => {
                    CartService.sendInvites(scope.configuration.emails)
                        .then(() => {
                            dialogService.hide();
                            CartService.resetCart();
                            //return this._fetchParticipants();
                        })
                        .catch(error => this._messageService.showErrorPopupForResponse(error));
                };

                scope.prepareSendingInvitations = (emails) => {
                    scope.$broadcast(Constants.Events.ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE);
                    scope.readOnly = true;
                    scopeUtils.apply(scope);
                };

                scope.onDeleteContact = (contact) => {
                    this._rootScope.$broadcast(Constants.RootEvents.DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE, contact);
                }
            }]
        };

        this._dialogService.show(this._inviteMoreOption);
        await this._localForageService.remove(Constants.SessionStorage.CREATE_ORDER_CURRENT_TAB);
    }

    onWindowUnloading(context) {
        if (!this.orderSetupDialogShowing) {
            return;
        }
    }

    async createOrder(needAddItem) {

        if (!(await this._sessionService.loggedIn())) {
            await this._authenticationService.showLoginDialog('', 'facade', true);
        }

        if (this.isOrderCreating)
            return false;

        this.isOrderCreating = true;

        await this._showOrderSetupDialog({
            needAddItem
        });

        this.isOrderCreating = false;

        return true;
    }

    async editOrder(tabId) {
      console.log('editOrder');
        const cart = await this._cartService.getCart();
        let configuration = await this._cartService.getCartDetails(cart);
        console.log(configuration);
        configuration = await this._showOrderSetupDialog({
            tabToShow: tabId,
            initialConfiguration: configuration,
            initialCart: cart,
            __editMode: true
        });
        if (!configuration) {
            return null;
        }
        await this._cartService.setCartDetails(configuration);
        cart.cartName = configuration.customCartNameSetting.customCartNames === '1' ? configuration.customCartNameSetting.cartName : '';
        if(configuration.customCartNameSetting.customCartNames === '1' && configuration.customCartNameSetting.cartName !== ''){
            communicationService.requestToParent(commandKeys.updateMyCartButtonText, {cartNameValue: configuration.customCartNameSetting.cartName});
        }
        cart.orderLimit = isNaN(configuration.price) ? null : Number(configuration.price);
        cart.closeOn = configuration.deadlineTime;
        await this._cartService.setCartConfiguration(cart);
    }

    async continueOrder(paymentOptions) {
        if (!(await this._sessionService.loggedIn())) {
            await this._authenticationService.showLoginDialog('', 'facade', true);
        }

        await this._showOrderSetupDialog({
            paymentOptions
        });
    }

    async showInvitePreview() {
        const cart = await this._cartService.getCart();
        let configuration = await this._cartService.getCartDetails(cart);
        await this._showOrderSetupDialog({
            tabToShow: Constants.OrderSetupTabs.INVITE_WELCOME,
            initialConfiguration: configuration,
            initialCart: cart
        });

    }
}

module.service('OrderSetupService', OrderSetupService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/OrderSetupService.js